










import Vue from 'vue';

export default Vue.extend({
  name: 'MStoreSpinnerButton',
  props: {
    size: {
      type: String
    },
    buttonVariant: {
      type: String,
      default: 'primary'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    buttonType: {
      type: String,
      default: 'button'
    },
    action: {
      type: Function
    },
    isParentSubmitting: {
      type: Boolean
    },
    icon: {
      type: String
    }
  },
  data() {
    return {
      isSubmitting: false
    };
  },
  methods: {
    async onClick(this: any) {
      if (this.action) {
        this.$emit('is-submitting', true);
        this.isSubmitting = true;
        try {
          await this.action();
        } catch (error) {
          this.$log(error);
        } finally {
          this.isSubmitting = false;
          this.$emit('is-submitting', false);
        }
      }
    }
  }
});
